import BRANDS from "./brands";

// logos
import genericLogo from "../assets/branding/logos/alsea-white.svg";
import starbucksLogo from "../assets/branding/web-3X/starbucks-home.png";
import vipsLogo from "../assets/branding/web-3X/VIPS-home.png";
import burgerkingLogo from "../assets/branding/web-3X/BK-home.png";
import dominosLogo from "../assets/branding/web-3X/DP-home.png";
import italiannisLogo from "../assets/branding/web-3X/ITALIANNIS-home.png";
import chilisLogo from "../assets/branding/web-3X/chilis-home.png";
import pfchangsLogo from "../assets/branding/web-3X/PFC-home.png";
import cheesecakeLogo from "../assets/branding/web-3X/TCCF-home.png";
import chipotleLogo from "../assets/branding/web-3X/chipotle-home.png";
import sazoneWhiteLogo from "../assets/branding/web-3X/sazone-home.png";

// logos por marca
const BRAND_LOGOS = {
  DEFAULT: {
    src: genericLogo,
    alt: "Alsea",
  },
  [BRANDS.STARBUCKS.id]: {
    src: starbucksLogo,
    alt: "Starbucks",
  },
  [BRANDS.VIPS.id]: {
    src: vipsLogo,
    alt: "Vips",
  },
  [BRANDS.BURGERKING.id]: {
    src: burgerkingLogo,
    alt: "Burger King",
  },
  [BRANDS.DOMINOS.id]: {
    src: dominosLogo,
    alt: "Dominos",
  },
  [BRANDS.ITALIANNIS.id]: {
    src: italiannisLogo,
    alt: "Italiannis",
  },
  [BRANDS.CHILIS.id]: {
    src: chilisLogo,
    alt: "Chilis",
  },
  [BRANDS.PFCHANGS.id]: {
    src: pfchangsLogo,
    alt: "P.F. Changs",
  },
  [BRANDS.CHEESECAKE.id]: {
    src: cheesecakeLogo,
    alt: "The Cheesecake Factory",
  },
  [BRANDS.CHIPOTLE.id]: {
    src: chipotleLogo,
    alt: "Chipotle",
  },
  [BRANDS.SAZONE.id]: {
    src: sazoneWhiteLogo,
    alt: "Sazone",
  },
  [BRANDS.PORTON.id]: {
    src: genericLogo, // no logo
    alt: "El Porton",
  },
};

export const getBrandLogo = (brandId) => {
  if (!brandId) return BRAND_LOGOS.DEFAULT;
  return BRAND_LOGOS[brandId] || BRAND_LOGOS.DEFAULT;
};
